var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("x-grid", {
        ref: "grid",
        attrs: {
          id: "childGrid",
          columns: _vm.columns,
          "toolbar-config": _vm.toolbarConfig,
          editable: true,
          "edit-rules": _vm.editRules,
          editConfig: _vm.editConfig,
        },
        scopedSlots: _vm._u(
          [
            {
              key: _vm.toolbarConfig.templatelSlots,
              fn: function () {
                return [
                  _c(
                    "vxe-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.visible = true
                        },
                      },
                    },
                    [_vm._v("新增")]
                  ),
                  _c(
                    "vxe-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.delRow()
                        },
                      },
                    },
                    [_vm._v("删除")]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "a-modal",
        {
          attrs: {
            forceRender: "",
            title: "选择角色",
            width: 800,
            "ok-text": "确认",
            "cancel-text": "取消",
          },
          on: {
            ok: function ($event) {
              return _vm.handleOk("roleTableModal")
            },
            cancel: function ($event) {
              return _vm.handleClose("roleTableModal")
            },
          },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _vm.visible
            ? _c("roleTableModal", {
                ref: "roleTableModal",
                on: { getTableData: _vm.getTableData },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }